<div class="related-office remax-gradient-blue text-center">
  <b>{{ relatedOffice.officeName }}:</b> {{ relatedOffice.address1 }}, {{relatedOffice.city}},
  {{relatedOffice.state}}, {{relatedOffice.postalCode | formatPostalCode }} &nbsp;
  <span class="hide-on-tablet-down"> | &nbsp;</span>
  <br class="hide-on-tablet-landscape-up" />
  <b>{{'my-account.phone' | translate | uppercase}}:</b>
  {{ relatedOffice.telephone }}
</div>
